import type {CaseReducer, PayloadAction} from '@reduxjs/toolkit'

import type {PipelineDraftState} from './EditPipelinePage.slices.types'
import {getJob} from './EditPipelinePage.slices.utils'

export const setDependencies: CaseReducer<
  PipelineDraftState,
  PayloadAction<{
    id: string
    jobId: string
    dependencies: string[]
    branch: string
  }>
> = (state, action) => {
  const {id, jobId, dependencies, branch} = action.payload
  const job = getJob(state, id, jobId, branch)

  if (job != null) {
    const {dependencies: jobDependencies = []} = job
    job.dependencies = dependencies.map(dependency => {
      const dependencyWithFiles = jobDependencies.find(
        jobDependency => typeof jobDependency === 'object' && dependency in jobDependency,
      )

      return dependencyWithFiles || dependency
    })
  }
}

export const setFilesDependencies: CaseReducer<
  PipelineDraftState,
  PayloadAction<{
    id: string
    jobId: string
    dependencyId: string
    files?: readonly string[]
    runJobIfUpstreamFails?: boolean
    branch: string
  }>
> = (state, action) => {
  const {id, jobId, dependencyId, files, runJobIfUpstreamFails, branch} = action.payload
  const job = getJob(state, id, jobId, branch)

  if (job == null) {
    return
  }

  job.dependencies ??= []
  const dependencyIndex = job.dependencies.findIndex(dependency => {
    const isDependencyObject = typeof dependency === 'object' && dependency[dependencyId]

    return isDependencyObject || dependency === dependencyId
  })

  const existingDependency = job.dependencies[dependencyIndex]
  const existingSettings: {files?: readonly string[]; 'run-job-if-upstream-fails'?: boolean} =
    typeof existingDependency === 'object' ? (existingDependency[dependencyId] ?? {}) : {}

  const settings: {files?: readonly string[]; 'run-job-if-upstream-fails'?: boolean} = {
    ...existingSettings,
  }

  if (files !== undefined) {
    if (files.length > 0) {
      settings.files = files
    } else {
      delete settings.files
    }
  }

  if (runJobIfUpstreamFails !== undefined) {
    if (runJobIfUpstreamFails) {
      settings['run-job-if-upstream-fails'] = true
    } else {
      delete settings['run-job-if-upstream-fails']
    }
  }

  job.dependencies[dependencyIndex] =
    Object.keys(settings).length > 0 ? {[dependencyId]: settings} : dependencyId
}
